/**
  * Check if breakpoint is mobile.
  *
  * @param {String} breakpoint - current breakpoint
  * @returns {Boolean} Mobile or not.
  * @public
  * @TODO
  */
export default function isMobile(breakpoint) {
  return ['mobile', 'phablet'].includes(breakpoint);
}
